import * as React from 'react';
import './HomeButton.css';
import {Button} from "@mui/material";

/**
 * Customisable link button with a specific style (used on the home page).
 * @author Alizée Grand
 * @version 1.1
 * @creation 29/06/2022
 * @last_update 11/07/2022
 **/
class HomeButton extends React.Component<{
    /**
     * Path to the icon on the left of the button.
     */
    iconPath: string,
    /**
     * Text visible on the button.
     */
    children: string,
    /**
     * Link from the destination page to the button click.
     */
    destination: string
}> {
    render() {
        return (
            <Button id="home-button-button" href={this.props.destination}>
                <img src={this.props.iconPath} alt="Operation icon" id="home-button-button-icon"/>
                <p id="home-button-button-content">
                    {this.props.children}
                </p>
            </Button>
        );
    }
}

export default HomeButton;
